"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgDraft(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M15.121.293l2.586 2.586a1 1 0 01.293.707V8h2v8H4V8h2V1a1 1 0 011-1h7.414a1 1 0 01.707.293zM13 2H8v6h2c0 1.657 1.343 2 2 2s2-.343 2-2h2V5h-2a1 1 0 01-1-1z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Draft')(SvgDraft);
//# sourceMappingURL=Draft.js.map